export const COMMUNES_SPECIFIQUES = ['Arcachon', 'Lège-Cap Ferret', 'Le Teich'];

export const isCommuneSpecifique = (ville) => {
  return COMMUNES_SPECIFIQUES.includes(ville);
};

export const COMMUNES_DPE_FILE = ['Le Teich'];

export const COMMUNES_DPE_CHECK = ['Le Teich', 'Arcachon', 'Lège-Cap Ferret'];

export const COMMUNES_DPE_CHECK_OPTIONAL = ['Lège-Cap Ferret'];

export const COMMUNES_PERSONNE_TYPE = ['Le Teich', 'Arcachon', 'Lège-Cap Ferret'];

export const isCommuneDPEFile = (ville) => {
  return COMMUNES_DPE_FILE.includes(ville);
};

export const isCommuneDPECheck = (ville) => {
  return COMMUNES_DPE_CHECK.includes(ville);
};

export const isCommuneDPECheckOptional = (ville) => {
  return COMMUNES_DPE_CHECK_OPTIONAL.includes(ville);
};

export const isCommunePersonneType = (ville) => {
  return COMMUNES_PERSONNE_TYPE.includes(ville);
};
